module.exports = __webpack_public_path__ + "img/warmtepomp.6674152.svg";